// components/TablePersonas.jsx
import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getPersonas,
  deletePersona,
  getPersonaById,
} from "../helpers/rutaPersonas";          // ← PLURAL
import ModalPersona from "./ModalPersona";  // ← usás este nombre en tu código

const COLS = {
  acciones: 90,
  nro: 60,
  nombre: 160,       // ajustá anchos a gusto
  domicilio: 200,
  telefono: 100,
  email: 220,
  localidad: 200,
  perfil: 100,
  activo: 70,
};

const cellTruncate = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const TablePersonas = () => {
  const [state, setState] = useState({ personas: [], loading: true, error: "" }); // ← personas (minúscula)
  const [persona, setPersona] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaPersonas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const consultaPersonas = async () => {
    try {
      const datos = await getPersonas();
      const lista =
        Array.isArray(datos?.personas) ? datos.personas :
        Array.isArray(datos)           ? datos :
        [];
      setState({ personas: lista, loading: false, error: "" });
    } catch (e) {
      setState(s => ({ ...s, loading: false, error: e?.message || "Error al cargar personas" }));
      console.error("❌ Error getPersonas:", e);
    }
  };

  const handleClose = () => { setShow(false); consultaPersonas(); };
  const handleShow  = () => setShow(true);

  const modificaPersona = (id) => {
    getPersonaById(id)
      .then((resp) => {
        // esperado: { ok, persona }
        const per = resp?.persona || resp;
        if (per?._id) { setPersona(per); handleShow(); }
        else { console.error("❌ Error al obtener persona:", resp?.error || resp); }
      })
      .catch(err => console.error("❌ Error getPersonaById:", err));
  };

  const eliminarPersona = (id) => {
    if (window.confirm("¿Está seguro que desea borrar la persona?")) {
      deletePersona(id)
        .then(() => consultaPersonas())
        .catch(err => console.error("❌ Error deletePersona:", err));
    }
  };

  if (state.loading) return <div className="p-3">Cargando personas…</div>;
  if (state.error)   return <div className="p-3 text-danger">{state.error}</div>;

  const rows = state.personas.filter(p => p?.activo ?? true);

  return (
    <div className="table-container">
      <div className="col-12 mt-4" />
      <div>
        <Table
          striped
          bordered
          hover
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <thead>
            <tr>
              <th style={{ width: COLS.acciones }}>Acciones</th>
              <th style={{ width: COLS.nro }}>Nro</th>
              <th style={{ width: COLS.nombre }}>Nombre</th>
              <th style={{ width: COLS.domicilio }}>Domicilio</th>
              <th style={{ width: COLS.telefono }}>Teléfono</th>
              <th style={{ width: COLS.email }}>Email</th>
              <th style={{ width: COLS.localidad }}>Localidad</th>
              <th style={{ width: COLS.perfil }}>Perfil</th>
              <th style={{ width: COLS.activo }}>Activo</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={9} className="text-center">No hay personas.</td>
              </tr>
            ) : (
              rows.map((p) => (
                <tr key={p._id || p.id}>
                  <td style={{ width: COLS.acciones, whiteSpace: "nowrap" }}>
                    <div style={{ display: "flex", gap: 8, flexWrap: "nowrap", justifyContent: "center" }}>
                      <button className="btn btn-primary" onClick={() => modificaPersona(p._id || p.id)}>
                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                      </button>
                      <button className="btn btn-danger" onClick={() => eliminarPersona(p._id || p.id)}>
                        <i className="fa fa-trash-o" aria-hidden="true" />
                      </button>
                    </div>
                  </td>

                  <td style={{ width: COLS.nro }}>{p.codper}</td> {/* ← codper (no codcli) */}
                  <td style={{ width: COLS.nombre, textAlign: "left", ...cellTruncate }}>{p.nombre}</td>
                  <td style={{ width: COLS.domicilio, textAlign: "left", ...cellTruncate }}>{p.domicilio || "-"}</td>
                  <td style={{ width: COLS.telefono }}>{p.telefono || "-"}</td>
                  <td style={{ width: COLS.email, ...cellTruncate }}>{p.email || "-"}</td>
                  <td style={{ width: COLS.localidad, ...cellTruncate }}>
                    {p.localidad?.descripcion || p.localidad?.localidad || "-"}
                  </td>
                  <td style={{ width: COLS.perfil }}>{p.perfil || "-"}</td>
                  <td style={{ width: COLS.activo }}>{(p.activo ?? true) ? "Sí" : "No"}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <ModalPersona show={show} handleClose={handleClose} persona={persona} />
    </div>
  );
};

export default TablePersonas;
